
const getDefaultState = () => ({
        dashboard: null,
})

const state = getDefaultState()

const getters = {
    getterDashboard(state){
        return state.dashboard
    }
}

const actions = {
    async getDashboard ({commit}) {

        try{
            
            const {data} = await axios.get(`/api/user/dashboard`)
            commit('setterDashboard', data.data)

        }
        catch (e){

            console.error('dashboard' , e)

        }


    },
}

const mutations = {

        resetDashboard(state){
            Object.assign(state, getDefaultState())
        },

        setterDashboard(state, data){
            state.dashboard = data
        },

}

export default {
    state,
    getters,
    mutations,
    actions,
}
